import { FeatureLimits } from '../types/limits';

export const FEATURE_LIMITS: Record<string, FeatureLimits> = {
  free: {
    eventsPerMonth: 1,
    totalGuests: 5,
    totalRecipes: 5,
    totalInventoryItems: 30,
    guestGroups: 2,
    activeShoppingLists: 1,
    wishlistItems: 5,
    customCategories: 0,
    photosPerEvent: 10,
    videosPerEvent: 2
  },
  premium: {
    eventsPerMonth: 10,
    totalGuests: 50,
    totalRecipes: 30,
    totalInventoryItems: 100,
    guestGroups: 10,
    activeShoppingLists: 5,
    wishlistItems: 30,
    customCategories: 15,
    photosPerEvent: 50,
    videosPerEvent: 10
  },
  basic: {
    eventsPerMonth: 10,
    totalGuests: 50,
    totalRecipes: 30,
    totalInventoryItems: 100,
    guestGroups: 10,
    activeShoppingLists: 5,
    wishlistItems: 30,
    customCategories: 15,
    photosPerEvent: 50,
    videosPerEvent: 10
  },
  trial: {
    eventsPerMonth: 10,
    totalGuests: 50,
    totalRecipes: 30,
    totalInventoryItems: 100,
    guestGroups: 10,
    activeShoppingLists: 5,
    wishlistItems: 30,
    customCategories: 15,
    photosPerEvent: 50,
    videosPerEvent: 10
  },
  pro: {
    eventsPerMonth: -1,
    totalGuests: -1,
    totalRecipes: -1,
    totalInventoryItems: -1,
    guestGroups: -1,
    activeShoppingLists: -1,
    wishlistItems: -1,
    customCategories: -1,
    photosPerEvent: -1,
    videosPerEvent: -1
  }
};
